<template>
  <div class="duration-wrapper">
    <div class="checkbox-row">
      <v-checkbox
        :readonly="readonly"
        v-model="indoor"
        label="Drinnen"
        color="#33bbff"
        hide-details
        @change="changeIndoor($event)"
      ></v-checkbox>

      <v-checkbox
        :readonly="readonly"
        v-model="outdoor"
        label="Draussen"
        color="#33bbff"
        @change="changeIndoor($event)"
        hide-details
      ></v-checkbox>

      <v-checkbox
        :readonly="readonly"
        v-model="none"
        label="Nicht anwendbar"
        color="#33bbff"
        :disabled="none == 1"
        @change="changeNone($event)"
        hide-details
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "readonly"],
  data() {
    return {
      checked: "in",
      indoor: this.value.indoor ? 1 : 0,
      outdoor: this.value.outdoor ? 1 : 0,
      none: this.value.indoor == 0 && this.value.outdoor == 0 ? 1 : 0,
    };
  },
  methods: {
    changeIndoor(event) {
      if (
        (this.indoor == 0 || this.indoor == null) &&
        (this.outdoor == 0 || this.outdoor == null)
      ) {
        this.none = 1;
      } else {
        this.none = 0;
      }
      this.$emit("input", { indoor: this.indoor, outdoor: this.outdoor });
    },
    changeNone($event) {
      this.indoor = 0;
      this.outdoor = 0;
      this.$emit("input", { indoor: this.indoor, outdoor: this.outdoor });
    },
  },
  mounted() {},
  computed: {},
};
</script>

<style>
</style>